import React from 'react';

function Contacts() {
  return (
   
     
     <div className="about__wrapper contacts_wrp">
     <h3>Контакты</h3>
     <p>
     Москва, Россия
<br />
<br />
<a href="mailto:info@ptburo.com">info@ptburo.com</a>
<br />
<br />
<a href="tel:+79167371319"> Tel: +7 916 737 13 19</a>
      </p>
    </div>
    
  );
}

export default Contacts;
